import { DateFormatOptions } from 'shared/types/date-format-options';

export const formatDateInput = (
  value: string,
  dateFormat: DateFormatOptions,
): string => {
  const partLengths = dateFormat.split('-').map((part) => part.length);
  const cleaned = value.replace(/\D/g, '');

  let formattedValue = cleaned;
  partLengths.reduce((currentIndex, partLength, i) => {
    if (cleaned.length > currentIndex + partLength) {
      formattedValue =
        formattedValue.slice(0, currentIndex + partLength + i) +
        '-' +
        formattedValue.slice(currentIndex + partLength + i);
      return currentIndex + partLength;
    }
    return currentIndex;
  }, 0);

  return formattedValue;
};
